import { GetServerSideProps } from 'next'
import Layout from '../components/layouts/Layout'
import { useState } from 'react'
import withoutAuth from '../lib/withoutAuth'
import RequestForm, { RequestData } from '../components/auth/RequestForm'

const requestAccount = async (email): Promise<any> => {
  const response = await fetch('/api/v1/auth/request-account', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email }),
  })

  const data = await response.json()
  return data
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  return withoutAuth(context)(async () => {
    return {
      props: {},
    }
  })
}

export default function Login(): JSX.Element {
  const [requestError, setRequestError] = useState(undefined)
  const [requestSuccess, setRequestSuccess] = useState(undefined)
  const [successDescription, setSuccessDescription] = useState(undefined)

  const requestAccountFn = async (data: RequestData) => {
    try {
      const result = await requestAccount(data.email)
      if (!result.error) {
        setRequestSuccess(`Your request for a new account was successful.`)
        setSuccessDescription(
          `Instructions were sent to ${data.email}. Please check your email and click the link to complete setting up your new account.`
        )
      } else {
        setRequestError(result.error)
      }
    } catch (error) {
      setRequestError('Request failed. Try again later.')
    }
  }

  return (
    <Layout title="Request Account">
      <div className="card-container">
        <RequestForm
          title="Request an Account"
          description="Please enter you email address and we well send you instructions to setup your account."
          requestError={requestError}
          requestSuccess={requestSuccess}
          requestSuccessDescription={successDescription}
          onSubmit={requestAccountFn}
        />
      </div>
    </Layout>
  )
}
